import ErrorMessagePage from "./ErrorMessagePage";
import MessagePage from "./MessagePage";

export { ErrorMessagePage };
export default MessagePage;
